import React from 'react';

/**
 * Numbered / titled section for legal-style pages.
 */
const UtilitySection = ({ title, children }) => (
  <section className="utility-section">
    <h2 className="utility-section__title">{title}</h2>
    <div className="utility-prose">{children}</div>
  </section>
);

export default UtilitySection;
